export const getSizeBodyTemplate = (mailId: string) =>
  `<GetItem
    xmlns="http://schemas.microsoft.com/exchange/services/2006/messages"
    xmlns:t="http://schemas.microsoft.com/exchange/services/2006/types"
  >
    <ItemShape>
      <t:BaseShape>IdOnly</t:BaseShape>
      <t:AdditionalProperties>
        <t:FieldURI FieldURI="item:Size" />
      </t:AdditionalProperties>
    </ItemShape>
    <ItemIds>
      <t:ItemId Id="${mailId}" />
    </ItemIds>
  </GetItem>
`;
